Foundation = Foundation || {};
Foundation.Mobile = Foundation.Mobile || {};


window['Foundation']['Mobile'] = Foundation.Mobile;

jQuery.fn['listview'] = function () {
    // if(console && console.warn){
    //     console.warn('jQuery.mobile listview shim executed.');
    // }
}

jQuery.mobile.showPageLoadingMsg = function () {
    // if(console && console.warn){
    //     console.warn('jQuery.mobile showPageLoadingMsg shim executed.');
    // }
};

Foundation.Mobile.Util = Foundation.Mobile.Util || {};

Foundation.Mobile.Util.smoothScroll = function (pos) {
    jQuery('html,body').animate({
        scrollTop:pos
    }, 200);
    return false;
}
